<template>
  <v-container fluid :class="mobile ? 'container-mobile' : 'container'">
    <!-- PC: Show image on side -->
    <v-row v-if="!mobile">
      <v-col cols="3">
        <v-card class="mx-auto" elevation="5">
          <v-img
            :lazy-src="'images/about/low_res/' + image"
            :src="'images/about/' + image"
          />
        </v-card>
      </v-col>
      <v-col>
        <h1>{{ title }}</h1>
        <p
          v-for="text in paragraphs"
          v-html="text"
          :key="text"
          class="paragraph"
        />
      </v-col>
    </v-row>

    <!-- mobile: Show image above text -->
    <v-row v-if="mobile">
      <v-col>
        <v-card class="mx-auto" elevation="5" max-width="300px">
          <v-img
            :lazy-src="'images/about/low_res/' + image"
            :src="'images/about/' + image"
          />
        </v-card>
        <h1 class="title-mobile">{{ title }}</h1>
        <p
          v-for="text in paragraphs"
          v-html="text"
          :key="text"
          class="paragraph-mobile"
        />
      </v-col>
    </v-row>
    <v-divider />
  </v-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    paragraphs: {
      type: Array,
    },
    image: {
      type: String,
    },
    mobile: {
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.paragraph {
  font-size: 18px;
  padding-top: 6px;
  padding-bottom: 6px;
  margin: 0px;
}
.paragraph-mobile {
  margin-top: 6px;
  margin-bottom: 6px;
}
.container {
  padding: 6px 64px;
}
.container-mobile {
  padding: 6px 24px;
}
.title-mobile {
  text-align: center;
  margin: 12px 6px 6px 6px;
}
</style>